export default "__VITE_ASSET__8980c4a2__"